import { axios } from '@/utils/request'
// 查询资金 /fund/get
const getFund = (params) => {
    return axios({
        url: '/fund/get',
        method: 'post',
        data: params
    })
}
// /stock/shares 查询持仓
const getStockShares = (params) => {
    return axios({
        url: '/stock/shares',
        method: 'post',
        data: params
    })
}
// /trade/add_note 添加投资笔记
const getTradeAddNote = (params) => {
    return axios({
        url: '/trade/add_note',
        method: 'post',
        data: params
    })
}
// /trade/get_notes_page 投资笔记列表-分页
const getTradeList = (params) => {
    return axios({
        url: '/trade/get_notes_page',
        method: 'post',
        data: params
    })
}
// /trade/get_profit_data 查询账户数据分析
const getTradeProfit = (params) => {
    return axios({
        url: '/trade/get_profit_data',
        method: 'post',
        data: params
    })
}
// /trade/delete_note 删除笔记
const getDeleteNote = (params) => {
    return axios({
        url: '/trade/delete_note',
        method: 'post',
        data: params
    })
}

// /stock/deal 成交
const getStockDeal = (params) => {
    return axios({
        url: '/stock/deal',
        method: 'post',
        data: params
    })
}
// /order/list 委托列表
const getOrderList = (params) => {
    return axios({
        url: '/order/list',
        method: 'post',
        data: params
    })
}
// /trade/get_proft_line 收益走势图
const getProftLine = (params) => {
    return axios({
        url: '/trade/get_proft_line',
        method: 'post',
        data: params
    })
}
// /trade/get_share_layout 持仓分布
const getShareLayout = (params) => {
    return axios({
        url: '/trade/get_share_layout',
        method: 'post',
        data: params
    })
}
// /trade/get_profit 获取账户收益
const getProfit = (params) => {
    return axios({
        url: '/trade/get_profit',
        method: 'post',
        data: params
    })
}
// /stock/witorder 撤单
const getWitorder = (params) => {
    return axios({
        url: '/stock/witorder',
        method: 'post',
        data: params
    })
}
// /stock/creorder 创建订单
const getCreorder = (params) => {
    return axios({
        url: '/stock/creorder',
        method: 'post',
        data: params
    })
}
// /trade/create创建策略（加密）
const getCreate = (params) => {
    return axios({
        url: '/trade/create_account',
        method: 'post',
        data: params
    })
}
const getStockReal = (params) => {
    return axios({
        url: '/quote/stockReal',
        method: 'post',
        data: params
    })
}

// /touxing/token
const getToken = (params) => {
    return axios({
        url: '/touxing/token',
        method: 'post',
        data: params
    })
}
// /trade/clear 重置账号
const getClear = (params) => {
    return axios({
        url: '/trade/clear',
        method: 'post',
        data: params
    })
}
// trade/move 账户下移
const getTradeMove = (params) => {
    return axios({
        url: '/trade/update_accounts',
        method: 'post',
        data: params
    })
}
export default {
    getFund,
    getStockShares,
    getTradeAddNote,
    getTradeList,
    getTradeProfit,
    getDeleteNote,
    getStockDeal,
    getOrderList,
    getProftLine,
    getShareLayout,
    getProfit,
    getWitorder,
    getCreorder,
    getCreate,
    getStockReal,
    getToken,
    getClear,
    getTradeMove

}
